import Config from "src/Config"
import { superAdminFetch } from "./superAdminFetch"

export interface ISystemApiError {
	code?: number
	message?: string
	details?: unknown
	[key: string]: unknown
}

export type TSystemApiResponse<T> =
	| { data: T; error?: never }
	| { data?: never; error: ISystemApiError }

/** Shared POST contract for the newer system endpoints. */
export const systemPost = async <T>(
	token: string,
	method: string,
	body: Record<string, unknown> = {}
): Promise<TSystemApiResponse<T>> => {
	try {
		const response = await superAdminFetch(Config.scheme.URL_API + method, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(body)
		})
		const payload = await response.json() as TSystemApiResponse<T>
		if (payload.error) return { error: payload.error }
		if (!response.ok) return { error: { code: response.status, message: response.statusText || "Request failed" } }
		return payload
	} catch (cause) {
		return { error: { code: -1, message: cause instanceof Error ? cause.message : "Request failed" } }
	}
}

export const systemErrorMessage = (error: ISystemApiError) =>
	String(error.message || error.details || "Request failed")

/** For endpoints whose ready-to-show text is in error.details. */
export const systemErrorDetails = (error: ISystemApiError) =>
	String(error.details || error.message || "Request failed")
